/* KINESA · copyright + no-download protection
   Blocks casual right-click save, drag-to-save, iOS long-press save, copy/print/view-source shortcuts.
   Does NOT prevent screenshots or determined dev-tool access (impossible client-side). */
(function(){
  // 1. block right-click context menu globally
  document.addEventListener('contextmenu', function(e){
    var t = e.target.tagName;
    // allow context menu inside form inputs (so users can paste address, etc.)
    if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
    e.preventDefault();
  });

  // 2. block drag-start on images / videos / canvases
  document.addEventListener('dragstart', function(e){
    var t = e.target.tagName;
    if (t === 'IMG' || t === 'VIDEO' || t === 'CANVAS' || t === 'PICTURE') {
      e.preventDefault();
    }
  });

  // 3. block save / view-source / print keyboard shortcuts (Ctrl/Cmd combos)
  document.addEventListener('keydown', function(e){
    if (!(e.ctrlKey || e.metaKey)) return;
    var k = (e.key || '').toLowerCase();
    if (k === 's' || k === 'u' || k === 'p') {
      e.preventDefault();
      e.stopPropagation();
    }
  });

  // 4. block "Save Image" copy on iOS Safari (long-press triggers contextmenu; covered above)
  //    but also block touchstart hold from triggering callout — add inline guard:
  document.addEventListener('touchend', function(e){
    var t = e.target.tagName;
    if (t === 'IMG' || t === 'VIDEO') {
      // do not prevent default — would break taps. We rely on CSS -webkit-touch-callout:none.
    }
  }, { passive: true });

  // 5. block copy of body content (still allows form inputs)
  document.addEventListener('copy', function(e){
    var sel = window.getSelection ? window.getSelection().toString() : '';
    var ae = document.activeElement;
    var inField = ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA');
    if (!inField && sel.length > 0) {
      e.preventDefault();
      try { e.clipboardData.setData('text/plain', '© KINESA - turinys autoriaus saugomas.'); } catch(_){}
    }
  });
})();
